import React, { Component } from 'react';
import PubSub from 'pubsub-js';

import '../css/Footer.css';

class Footer extends Component {
    constructor() {
        super();

        this.state = {
            lang: "pt"
        };

        this.locationTexts = {
            "direitos": { 
                "pt": "Todos direitos reservados",
                "es": "Todos los derechos reservados", 
                "en": "All rights reserved"
            },
            "pt": { "pt": "Português", "es": "Portugués", "en": "Portuguese" },
            "es": { "pt": "Espanhol", "es": "Español", "en": "Spanish" },
            "en": { "pt": "Inglês", "es": "Inglés", "en": "English" },
            "empresa" : {
                "pt": "A Escolha Tecnologia atua no desenvolvimento de sites, sistemas e aplicativos multiplataformas.", 
                "es": "La Escolha Tecnologia actúa en el desarrollo de sitios, sistemas y aplicaciones multiplataformas.", 
                "en": "Escolha Technologia acts in the development of multiplatform sites, systems and applications."
            },
        };
    }

    componentWillMount(){
        PubSub.subscribe('language.change', (msg, lang) => this.setState({lang}));
    }

    render() {
        let texts= this.locationTexts;

        return (
            <footer>
                <div id="footer-top-content">
                    <div id="footer-top-textblock">
                        <div id="footer-top-header">Escolha Tecnologia</div>
                        <div id="footer-top-paragraph">
                        {texts["empresa"][this.state.lang]}
                    </div>
                    </div>
                    <div id="footer-top-socialnetwork">
                        <nav>
                            <a href="https://www.facebook.com/escolhatecnologia"><i className="fab fa-facebook-square"></i>&nbsp;&nbsp;Facebook</a>
                            <a href="https://www.instagram.com/escolhatecnologia/"><i className="fab fa-instagram"></i>&nbsp;&nbsp;Instagram</a>
                            <a href="https://twitter.com/escolhatec"><i className="fab fa-twitter"></i>&nbsp;&nbsp;Twitter</a>
                            <a href="https://www.youtube.com/channel/UCr632Bp9WjTKhkhzCioT1Pw"><i className="fab fa-youtube"></i>&nbsp;&nbsp;YouTube</a>
                        </nav>
                    </div>
                </div>

                <div id="footer-bottom-content">
                    <nav id="footer-bottom-language-nav">
                        <span onClick={() => PubSub.publish("language.change", "pt")}>{texts["pt"][this.state.lang]}</span>
                        <span onClick={() => PubSub.publish("language.change", "en")}>{texts["en"][this.state.lang]}</span>
                        <span onClick={() => PubSub.publish("language.change", "es")}>{texts["es"][this.state.lang]}</span>
                    </nav>
                    <div id="footer-bottom-copyright">
                        2018 {texts["direitos"][this.state.lang]} | Escolha Tecnologia
                </div>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/componentes/Footer.js